export default {
    "mitacVideo_error": "Error al conectar con la transmisión en vivo, por favor intente de nuevo.",
    "mitacVideo_deviceOffline": "El dispositivo está actualmente fuera de línea - no se puede transmitir en vivo",
}
